import baseApi from "./baseApi";

export const generateLayoutFromPrompt = async (prompt) => {
  const response = await baseApi.post("/agent/generate-layout", {
    prompt,
  });
  return response;
};

export const generateDescriptionsFromPrompt = async (prompt) => {
  const response = await baseApi.post("/agent/generate-descriptions", {
    prompt,
  });
  return response;
};
